import PropTypes from 'prop-types';

export const badgePropTypes = {
	badgeClasses: PropTypes.arrayOf(PropTypes.string),
	target: PropTypes.string,
	href: PropTypes.string,
	imageSrc: PropTypes.string.isRequired,
	imageAlt: PropTypes.string.isRequired,
	imageTitle: PropTypes.string,
	tooltip: PropTypes.string,
	disclaimer: PropTypes.string
};

export const badgeDefaultProps = {
	badgeClasses: [],
	disclaimer: '',
	href: null,
	target: null,
	imageTitle: '',
	tooltip: ''
};
